import { useEffect } from 'react'
import BtnCompartir from '../../components/js/BtnCompartir';
import styles from '../css/HomePage.module.css'

export const HomePage = () => {
  useEffect(() => {
    document.title = `Mercadito Natural Kiara`;
  });

  return (
    <>
      <div className={styles.containerHomePage}>
        <BtnCompartir
          url={"https://mercadito-natutal-kiara-v1-front.vercel.app/"}
        />
        <div className={styles.logoHomePage} />
        <a href="https://www.instagram.com/mercadito_natural_kiara/" className={styles.enlaceInstagram} target="_blank" rel="noopener noreferrer" title='Ir a instagram'>
          <div className={styles.containerLogoInstagram} />
          Mercadito natural Kiara
        </a>
        <a href="https://api.whatsapp.com/send/?phone=5493424293143" className={styles.enlaceWhatsapp} target="_blank" rel="noopener noreferrer" title='Ir a instagram'>
          <div className={styles.containerLogoWhatsapp} />
          342 4 293 143
        </a>
      </div>
    </>
  )
}
